var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/new-record") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 45 0 45 47.9999652 0 47.9999652"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 45 0 45 44.5217043 0 44.5217043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "7.03125e-05 0 45 0 45 44.5217043 7.03125e-05 44.5217043"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-743.000000, -777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/new-record",
    transform: "translate(743.000000, 777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,47.9999652 L22.5,47.9999652 C10.0736719,47.9999652 0,38.0333565 0,25.7390957 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,25.7390957 C45,38.0333565 34.9263281,47.9999652 22.5,47.9999652",
    id: "Fill-1",
    fill: "#AD8D07",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,44.5217043 L22.5,44.5217043 C10.0736719,44.5217043 0,34.5550957 0,22.2608348 L0,4.17387826 C0,1.86883478 1.88894531,-3.47826087e-05 4.21875,-3.47826087e-05 L40.78125,-3.47826087e-05 C43.1110547,-3.47826087e-05 45,1.86883478 45,4.17387826 L45,22.2608348 C45,34.5550957 34.9263281,44.5217043 22.5,44.5217043",
    id: "Fill-4",
    fill: "#FFDC4A",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,8.8674087 C22.2496875,8.8674087 21.9997266,8.99610435 21.8703516,9.25349565 L18.7530469,15.4590609 C18.6503906,15.6635826 18.4524609,15.8051478 18.2239453,15.8378435 L11.2619531,16.8319304 C10.6836328,16.9143652 10.4533594,17.6183652 10.873125,18.0201043 L15.9046875,22.838887 C16.0720313,22.998887 16.1483203,23.2301913 16.1085938,23.4569739 L14.9199609,30.2660174 C14.8208203,30.8336696 15.4219922,31.2677565 15.9380859,31.0013217 L22.1744531,27.7801043 C22.2767578,27.7272348 22.3882031,27.7008 22.5,27.7008 L22.5,8.8674087 Z",
    id: "Fill-7",
    fill: "#D3AB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1267695,18.0202783 C34.5465352,17.6181913 34.3166133,16.9145391 33.738293,16.8317565 L26.7759492,15.8380174 C26.5474336,15.8053217 26.3495039,15.6637565 26.2468477,15.458887 L23.129543,9.25332174 C23.0005195,8.99627826 22.750207,8.86758261 22.4998945,8.86758261 L22.4998945,27.7009739 C22.6116914,27.7009739 22.7234883,27.7274087 22.8254414,27.7799304 L29.0618086,31.0011478 C29.5779023,31.2679304 30.1790742,30.8338435 30.0799336,30.2661913 L28.8913008,23.4571478 C28.8519258,23.2303652 28.9282148,22.9990609 29.095207,22.8390609 L34.1267695,18.0202783 Z",
    id: "Fill-9",
    fill: "#B59408"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7813203,-3.47826087e-05 L4.21882031,-3.47826087e-05 C1.88901563,-3.47826087e-05 7.03125e-05,1.86883478 7.03125e-05,4.17387826 L7.03125e-05,22.2608348 C7.03125e-05,34.5550957 10.0737422,44.5217043 22.5000703,44.5217043 L22.5000703,44.5217043 C34.9263984,44.5217043 45.0000703,34.5550957 45.0000703,22.2608348 L45.0000703,4.17387826 C45.0000703,1.86883478 43.111125,-3.47826087e-05 40.7813203,-3.47826087e-05 M40.7813203,4.17387826 L40.7813203,22.2608348 C40.7813203,32.2340522 32.5804219,40.3477913 22.5000703,40.3477913 C12.4197188,40.3477913 4.21882031,32.2340522 4.21882031,22.2608348 L4.21882031,4.17387826 L40.7813203,4.17387826",
    id: "Fill-11",
    fill: "#D3AB05",
    mask: "url(#mask-6)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRecord);
export default __webpack_public_path__ + "static/media/new-record.6103e01e970a87b486aafb8e07ba4fc4.svg";
export { ForwardRef as ReactComponent };